// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1299":"css/app.6645","3692":"css/admin-app.6645"}[chunkId] + ".css";
};